import React, { useEffect, useState } from 'react'
import { Badge, Drawer, Modal, Rate, Select, Spin, Tag } from "antd";
import moment from 'moment';
import { Column, Line } from '@ant-design/charts';
import { InfoCircleFilled, InfoCircleOutlined } from '@ant-design/icons';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { authRequest } from '../../../../../common/request/authRequest';
import { Term } from '../../../menuUsers/keywords/entity/TermUtils';
import { DrawerPanelTitle, modalPanelStyles } from '../../../common/Drawers/DrawerPanelTitle';

export const CompetitorsModal = (props: { locationId: string, keyword: any, onClose: any }) => {

    const [history, setHistory] = useState<any>(null);    
    const { projectGroup } = useAuth();

    const config : any = {        
        //isStack: true,
        xField: 'x',
        yField: 'value',
        seriesField: 'category',
        legend: {
            position: 'right', // Set the legend position to 'right'
            // You can add more legend configurations here if needed
          },
        /*isPercent: true,*/        
        
        xAxis: {
			label: {
				formatter: (text: any) => {
					return moment(text, 'YYYY-MM').format('MMM YYYY');					
				},
				autoHide: true,
				autoRotate: true,
			},
		},
        yAxis: {
            label: {
              formatter: (value: string) => {
                return `${(100 * parseFloat(value)).toFixed(0)}%`;
              },
            },
          },          
          point: {
            size: 3,
            shape: 'circle',
            style: {
              fill: 'white',
              stroke: '#5B8FF9',
              lineWidth: 2,
            },
          },
          line: {
            style: {
              lineWidth: 30
            },
          },        
       /* interactions: [
            {
                type: 'element-highlight-by-color',
            },
            {
                type: 'element-link'
            },
        ],*/        
        label: {
            position: 'middle',
            content: (item:any) => {
                return `${(item.value * 100).toFixed(2)}%`;
            },
            style: {
                fill: 'black',
            },
            }            
        };

    useEffect(() => {
        setHistory(null);            
        authRequest(
          `${process.env.REACT_APP_API}/projects/${projectGroup.project}/geogrid/competitors/chart/${props.locationId}?keyword=${props.keyword.term}`,
            { method: 'GET' }
            )
            .then((data) => {      
                setHistory(data);                   
            })
            .catch((error) => {
                if (error && error.status === 401) {
                    if (error.data.message === 'Google') {
                      //history.push('/vincular', { from: location });
                    } else {
                        
                    }
                }
            });            
        }, []); 

        return (        
            <Modal                
                width={'80%'}
                open={true}            
                onCancel={props.onClose}
                style={{ background: '#F4F7FA' }}
                {...modalPanelStyles}
                title={<DrawerPanelTitle title="Competidores" />}>
                <div>
                    {history ? 
                    <>
                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                            <h2>Porcentaje en el <b>LOCALPACK</b></h2><Term keyword={props.keyword}/>
                        </div>
                        <p style={{color:'slategray'}}><InfoCircleOutlined/> Dado un grid el %localpack indica el porcentaje de puntos del grid donde el negocio está en las primeras posiciones, siendo por tanto un buen KPI para medir la visibilidad</p>
                        <Line style={{padding:'50px'}} data={history} {...config} height={350}/>   
                    </>
                    :
                    <div style={{display:'flex', justifyContent:'center', alignItems:'center', minHeight:'400px'}}><Spin/></div>
                    }
                </div>        
            </Modal>
    )
}


  